import React from "react";
import { Package, Hash, Phone, MapPin, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, FormTextarea } from "./SharedFormComponents";

export const GenericForm = ({ form, errors, handleInputChange, activeTab }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FormInput
        icon={<Package size={14} />}
        label="Title"
        required
        field="title"
        value={form.title}
        onChange={handleInputChange}
        error={errors.title}
        placeholder={`Enter ${activeTab} name`}
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Code"
        field="code"
        value={form.code}
        onChange={handleInputChange}
        error={errors.code}
        placeholder="Code"
      />
      {activeTab === "stores" && (
        <>
          <FormInput
            icon={<Phone size={14} />}
            label="Mobile"
            field="mobile"
            value={form.mobile}
            onChange={handleInputChange}
            error={errors.mobile}
            placeholder="Store phone"
          />
          <div className="md:col-span-2">
            <FormTextarea
              icon={<MapPin size={14} />}
              label="Address"
              required
              field="address"
              value={form.address}
              onChange={handleInputChange}
              error={errors.address}
              placeholder="Store location"
            />
          </div>
        </>
      )}
      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Additional notes..."
        />
      </div>
      <div className="md:col-span-2">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>
    </div>
  );
};
